import { FC } from "react";

/**
 * Slim banner shown at the top of the chat body while the socket is attempting to reconnect.
 */
export const ChatReconnectingBanner: FC = () => (
  <div className="flex shrink-0 items-center justify-center gap-2 border-b border-l-0 border-r-0 border-t-0 border-solid border-b-gray-100 bg-gray-50 px-4 py-2">
    <div className="h-3 w-3 animate-spin rounded-full border-2 border-gray-200 border-t-gray-500" />
    <span className="font-secondary text-xs text-gray-500">Reconnecting…</span>
  </div>
);
